import { regionConstants } from '../_actions/regions.actions';

export function regions(state = [], action) {
  switch (action.type) {
    case regionConstants.REGIONS_FETCH_SUCCESS:
      return action.regions;
    default:
      return state;
  }
}

export function regionsIsLoading(state = false, action) {
  switch (action.type) {
    case regionConstants.REGIONS_FETCH_REQUEST:
      return true;
    case regionConstants.REGIONS_FETCH_SUCCESS:
    case regionConstants.REGIONS_FETCH_FAILURE:
      return false;
    default:
      return state;
  }
}

export function regionsHasErrored(state = false, action) {
  switch (action.type) {
    case regionConstants.REGIONS_FETCH_FAILURE:
      return true;
    case regionConstants.REGIONS_FETCH_REQUEST:
    case regionConstants.REGIONS_FETCH_SUCCESS:
      return false;
    default:
      return state;
  }
}
